import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React__default from 'react';
/**
 * Detecs if on a mobile device.
 */

function isMobile() {
  // But first, detect if running on the browser in case of SSR:
  var isBrowser = typeof window !== 'undefined';

  if (isBrowser) {
    if (navigator && /Mobi|Android/i.test(navigator.userAgentData || navigator.userAgent)) return true;else return false;
  }

  return false;
}

var defaultProps = {
  isMobile: isMobile()
};
var ManagerStateContext = React__default.createContext(undefined);

function managerReducer(state, action) {
  switch (action.type) {
    case 'update-is-mobile':
      {
        return Object.assign(Object.assign({}, state), {
          isMobile: state.isMobile
        });
      }

    case 'register-slide':
      {
        var slides = state.slides;
        slides.set(action.payload.ref, {
          ref: action.payload.ref,
          number: slides.size + 1,
          label: action.payload.label
        });
        return {
          isMobile: state.isMobile,
          slides: slides,
          totalSlides: slides.size
        };
      }

    case 'remove-slide':
      {
        var _slides = state.slides;

        _slides.delete(action.payload);

        return {
          isMobile: state.isMobile,
          slides: _slides,
          totalSlides: _slides.size
        };
      }

    default:
      {
        throw new Error("Unhandled action: [".concat(JSON.stringify(action, null, 2), "]"));
      }
  }
}

function ManagerProvider(_ref) {
  var children = _ref.children,
      manager = _ref.manager;

  var _a;

  var _React__default$useRe = React__default.useReducer(managerReducer, {
    isMobile: (_a = manager === null || manager === void 0 ? void 0 : manager.isMobile) !== null && _a !== void 0 ? _a : defaultProps.isMobile,
    slides: new Map(),
    totalSlides: 0
  }),
      _React__default$useRe2 = _slicedToArray(_React__default$useRe, 2),
      state = _React__default$useRe2[0],
      dispatch = _React__default$useRe2[1];
  /**
   * Finds a Slide by its React `ref`.
   */


  var getSlide = function getSlide(ref) {
    return state.slides.get(ref);
  };
  /**
   * Registers a rendered Slide.
   */


  var registerSlide = function registerSlide(ref, label) {
    dispatch({
      type: 'register-slide',
      payload: {
        ref: ref,
        label: label
      }
    });
  };
  /**
   * Removes a Slide.
   */


  var removeSlide = function removeSlide(ref) {
    dispatch({
      type: 'remove-slide',
      payload: ref
    });
  };
  /**
   * If `manager.isMobile` prop changes, update the current state.
   */


  React__default.useEffect(function () {
    if (typeof (manager === null || manager === void 0 ? void 0 : manager.isMobile) === 'boolean') dispatch({
      type: 'update-is-mobile',
      payload: manager === null || manager === void 0 ? void 0 : manager.isMobile
    });
  }, [manager === null || manager === void 0 ? void 0 : manager.isMobile]); // NOTE: you *might* need to memoize this value
  // Learn more in http://kcd.im/optimize-context

  var value = {
    state: state,
    getSlide: getSlide,
    registerSlide: registerSlide,
    removeSlide: removeSlide
  };
  return React__default.createElement(ManagerStateContext.Provider, {
    value: value
  }, children);
}

function useManager() {
  var context = React__default.useContext(ManagerStateContext);

  if (context === undefined) {
    throw new Error('useManager must be used within a ManagerProvider');
  }

  return context;
}

export { ManagerProvider, useManager };